import SharedPreferences from "../../../constants/SharedPreferences";
import {
  saveInStorage,
} from "../../../util/Utility";
import BayunError from "../../../constants/BayunError";
import {
  getMessageFromSignatureString,
  retrieveAndverifyLastSignature,
  verifyMessageForPublicKeyTag,
  verifyAndSaveAdminPublicKey,
  verifyAndSaveBackdoorPublicKey,
  verifyMemberPublicKeyOwnership,
} from "../../../util/SignatureUtil";
import SigningPublicKeyTags from "../../../constants/SigningPublicKeyTags";
export async function verifyLockBoxResponse(
  sessionId,
  getMemberLockBoxResponse,
  memberPrivateKey,
) {
  // verify ghost member public key
  if (getMemberLockBoxResponse.ghostMemberPublicKey) {
    if (
      !(await verifyMessageForPublicKeyTag(
        sessionId,
        getMemberLockBoxResponse.ghostMemberPublicKey,
        "",
        SigningPublicKeyTags.BAYUN_SERVER_PUBLIC_KEY_TAG,
      ))
    ) {
      console.log("ghostMemberPublicKey verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    } else {
      await saveInStorage(
        sessionId,
        SharedPreferences.GHOST_MEMBER_SIGNING_PUBLIC_KEY,
        getMessageFromSignatureString(
          getMemberLockBoxResponse.ghostMemberPublicKey,
        ),
      );
      await saveInStorage(
        sessionId,
        SharedPreferences.GHOST_MEMBER_SIGNING_PUBLIC_KEY_WITH_SIGNATURES,
        getMemberLockBoxResponse.ghostMemberPublicKey,
      );
    }
  }

  // // verify and save memberPublicKey
  // if (getMemberLockBoxResponse.memberPublicKey) {
  //   if (
  //     !(await retrieveAndverifyLastSignature(
  //       sessionId,
  //       getMemberLockBoxResponse.memberPublicKey
  //     ))
  //   ) {
  //     console.log("memberPublicKey verification failed.");
  //     throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
  //   } else {
  //     await saveInStorage(
  //       sessionId,
  //       SharedPreferences.MEMBER_PUBLIC_KEY,
  //       getMessageFromSignatureString(
  //         getMemberLockBoxResponse.memberPublicKey
  //       )
  //     );
  //   }
  // }

  // verify and save memberPublicKey
  if (getMemberLockBoxResponse.memberPublicKey) {
    await verifyMemberPublicKeyOwnership(
      memberPrivateKey,
      getMemberLockBoxResponse.memberPublicKey,
      sessionId,
    );
    await saveInStorage(
      sessionId,
      SharedPreferences.MEMBER_PUBLIC_KEY,
      getMessageFromSignatureString(getMemberLockBoxResponse.memberPublicKey),
    );
  }

  // Signing keys must be trusted before anything that verifies against them. This block used to
  // sit after verifyAndSaveAdminPublicKey, which meant the admin key was persisted on the strength
  // of a memberSigningPublicKey that had not been verified yet — and because that function
  // short-circuits when a key is already stored, the unverified key was never re-checked on later
  // logins.
  if (getMemberLockBoxResponse.memberSigningPublicKey) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.memberSigningPublicKey,
      ))
    ) {
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
    await saveInStorage(
      sessionId,
      SharedPreferences.MEMBER_SIGNING_PUBLIC_KEY,
      getMessageFromSignatureString(
        getMemberLockBoxResponse.memberSigningPublicKey,
      ),
    );
  }

  await verifyAndSaveAdminPublicKey(
    sessionId,
    getMemberLockBoxResponse.adminPublicKey,
    getMemberLockBoxResponse.memberStatus,
    {},
    getMemberLockBoxResponse.memberSigningPublicKey,
  );

  await verifyAndSaveBackdoorPublicKey(
    sessionId,
    getMemberLockBoxResponse.backdoorPublicKey,
  );

  // verify and save orgKey_kek
  if (getMemberLockBoxResponse.orgKey_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.orgKey_kek,
      ))
    ) {
      console.log("orgKey_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  // verify and save orgPrivateKey_kek
  if (getMemberLockBoxResponse.orgPrivateKey_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.orgPrivateKey_kek,
      ))
    ) {
      console.log("orgPrivateKey_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  // verify and save orgPublicKey
  if (getMemberLockBoxResponse.orgPublicKey) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.orgPublicKey,
      ))
    ) {
      console.log("orgPublicKey verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    } else {
      await saveInStorage(
        sessionId,
        SharedPreferences.ORG_SIGNING_PUBLIC_KEY,
        getMessageFromSignatureString(getMemberLockBoxResponse.orgPublicKey),
      );
    }
  }

  // verify and save memberKey_kek
  if (getMemberLockBoxResponse.memberKey_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.memberKey_kek,
      ))
    ) {
      console.log("memberKey_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  if (getMemberLockBoxResponse.userSigningPublicKey) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.userSigningPublicKey,
      ))
    ) {
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
    await saveInStorage(
      sessionId,
      SharedPreferences.USER_SIGNING_PUBLIC_KEY,
      getMessageFromSignatureString(
        getMemberLockBoxResponse.userSigningPublicKey,
      ),
    );
  }

  // verify and save userPublicKey
  if (getMemberLockBoxResponse.userPublicKey) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.userPublicKey,
      ))
    ) {
      console.log("userPublicKey verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    } else {
      await saveInStorage(
        sessionId,
        SharedPreferences.USER_PUBLIC_KEY,
        getMessageFromSignatureString(getMemberLockBoxResponse.userPublicKey),
      );
    }
  }

  // verify and save memberPrivateKeyInner_kek
  if (getMemberLockBoxResponse.memberPrivateKeyInner_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.memberPrivateKeyInner_kek,
      ))
    ) {
      console.log("memberPrivateKeyInner_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  // verify and save memberPrivateKeyOuter_kek
  if (getMemberLockBoxResponse.memberPrivateKeyOuter_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.memberPrivateKeyOuter_kek,
      ))
    ) {
      console.log("memberPrivateKeyOuter_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  // verify and save memberSigningPrivateKey_kek
  if (getMemberLockBoxResponse.memberSigningPrivateKey_kek) {
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        getMemberLockBoxResponse.memberSigningPrivateKey_kek,
      ))
    ) {
      console.log("memberSigningPrivateKey_kek verification failed.");
      throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
    }
  }

  if (getMemberLockBoxResponse.memberStatus) {
    await saveInStorage(
      sessionId,
      SharedPreferences.MEMBER_STATUS,
      getMemberLockBoxResponse.memberStatus,
    );
  }

  // adminPrivateKey_kek with adminPublicKey

  // if (getMemberLockBoxResponse.adminPrivateKey_kek) {
  //   if (
  //     !(await retrieveAndverifyLastSignature(
  //       sessionId,
  //       getMemberLockBoxResponse.adminPrivateKey_kek
  //     ))
  //   ) {
  //     console.log("adminPrivateKey_kek verification failed.");
  //     throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
  //   }
  // }

  // backdoorPrivateKeyPart_kek with adminPublicKey
  // We are not using any where as of now might update in future.
  // if (getMemberLockBoxResponse.backdoorPrivateKeyPart_kek) {
  //   if (
  //     !(await retrieveAndverifyLastSignature(
  //       sessionId,
  //       getMemberLockBoxResponse.backdoorPrivateKeyPart_kek
  //     ))
  //   ) {
  //     console.log("backdoorPrivateKeyPart_kek verification failed.");
  //     throw BayunError.ERROR_MEMBER_VERIFICATION_FAILED;
  //   } else {
  //     await saveInStorage(
  //       sessionId,
  //       SharedPreferences.BACKDOOR_PRIVATE_KEY_PART_KEK,
  //       getMessageFromSignatureString(
  //         getMemberLockBoxResponse.backdoorPrivateKeyPart_kek
  //       )
  //     );
  //   }
  // }
}
